import { makeStateKey } from '@angular/platform-browser';

export class ContentCacheKeys {
  static readonly ContactUs = makeStateKey('CONTACT_US_KEY');
}
